import { PropsWithChildren } from 'react'

import { FormLayoutContext } from './context'
import { FormLayoutProps } from './interface'

export const FormLayout = ({
  children,
  ...props
}: PropsWithChildren<FormLayoutProps>) => {
  return <FormLayoutContext value={props}>{children}</FormLayoutContext>
}
